const baseName = '/dashboard';

module.exports = {
  manager: baseName + '/manager'
};
